import React from 'react';
import { Container, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ModelKeyInfoContent from '../../../components/usedVehicleCard/definition/ModelKeyInfoContent';

export default function MbvCodeGuide() {
  const { t } = useTranslation();

  return (
    <Container
      maxWidth='md'
      sx={{ py: 4 }}
    >
      <Typography
        variant='h4'
        component='h1'
        gutterBottom
      >
        {t('pageNames.mbvCodeGuide')}
      </Typography>
      <Paper
        variant='outlined'
        sx={{ p: 3 }}
      >
        <ModelKeyInfoContent />
      </Paper>
    </Container>
  );
}
